import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Group Info",
    href: (params) => `/book-testing/group/${params.orderId}/1`,
  },
  {
    label: "Schedule Tests",
    href: (params) => `/book-testing/group/${params.orderId}/2`,
  },
  {
    label: "Review & Finish",
    href: (params) => `/book-testing/group/${params.orderId}/3`,
  },
]

export const GroupStepper = () => {
  return <Stepper steps={steps} />
}
